import { isMobile } from 'react-device-detect';
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import { PaymentAmount } from "../../shared/PaymentAmount";
import PaymentMethodSelect from "../../shared/PaymentMethodSelect";
import { useEffect } from 'react';

const OplChooseMethod = () => {
  const { merchant, setMethodStepData, paymentParameters } = useOutletContext();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const navigate = useNavigate()

  useEffect(() => {
    if (!paymentParameters) {
      navigate(`/payto/${merchant.organisationId}`);
    }
  }, []);

  const onBankConfirmed = (institution) => {

    setMethodStepData({ method: "paybybank", institution });
    navigate(`/payto/${merchant.organisationId}/confirmpaybybank`);
  }

  return (paymentParameters && <div className="w-full flex flex-col lg:flex-row grow">
    <div id="request-info" className="lg:bg-zinc-50 lg:w-1/2 lg:border-r border-zinc-300 lg:pr-20 lg:pt-12 flex flex-col lg:items-end">
      <div className="lg:w-[440px]">
        <PaymentAmount amount={paymentParameters.amount} />
        {!isMobile && <div className="py-8 px-5 lg:px-0 border-b border-zinc-200 lg:border-0  ">
          <p className="text-zinc-500 mb-2">Reference</p>
          <p className="font-medium">{paymentParameters.reference}</p>
        </div>}
      </div>
    </div>
    <PaymentMethodSelect
      merchant={merchant}
      paymentError={error}
      onPayByBankSelected={onBankConfirmed}
      paymentParameters={paymentParameters}
      processingUrl={`/payto/${merchant.organisationId}/processing`}
      successUrl={`/payto/${merchant.organisationId}/success`}
    />
  </div>);
}
export default OplChooseMethod;

